import { render } from "./WhatsAppModalSidebarRightChatMessageContainerMessagesAudio.vue?vue&type=template&id=1946b504"
import script from "./WhatsAppModalSidebarRightChatMessageContainerMessagesAudio.vue?vue&type=script&lang=js"
export * from "./WhatsAppModalSidebarRightChatMessageContainerMessagesAudio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__